// extracted by mini-css-extract-plugin
export default {"container":"FN-z","dimension":"GN-z","dimensionLabels":"HN-z"};